import { css } from '@emotion/react';
import type { ComponentPropsWithoutRef } from 'react';

import IconX from '~icons/bx/x';

import { theme } from '@adflow/frontend/ui-theme';

import type { Button } from './Button';

const styles = {
	icon: css({
		color: theme.colors.icons.default,
		width: '1.5rem',
		height: '1.5rem',
	}),
	inlineButton: css({
		backgroundColor: theme.colors.white,
		display: 'grid',
		width: '2rem',
		height: '2rem',
		cursor: 'pointer',
		placeItems: 'center',
		borderBottomLeftRadius: '0.375rem',
		borderBottomRightRadius: '0.375rem',

		filter: 'drop-shadow(0px 8px 12px #0000001f);',
	}),
};

export function ButtonCancelInline(
	props: ComponentPropsWithoutRef<typeof Button>
) {
	return (
		<button type="button" {...props} css={styles.inlineButton}>
			<IconX css={styles.icon} />
		</button>
	);
}
